import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-text" }

import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Modal from "@/components/Modal.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useToast } from "primevue/usetoast";
import { Field } from "vee-validate";
import Dropdown from "primevue/dropdown";
import Update from "./Update.vue";
import JwtService from "@/core/services/JwtService";
//JSON.parse(JwtService.getUser()).roles.find(x => x.id != 2)

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const toast = useToast();
const store = useStore();
const isActive = ref(false);
const selectedSupplier = ref();
const supplierName: any = ref();

// Durum filtreleme seçenekleri
const statusOptions = ref([
  { label: "Aktif", value: true },
  { label: "Pasif", value: false },
]);

const toggleModal = () => {
  isActive.value = !isActive.value;
  supplierName.value = selectedSupplier.value.name;
};
const saveChanges = () => {
  console.log("ali");
};
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  name: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  isActive: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
});

//const sizeSetList = computed(() => store.state.DifferenceReasonModule.differenceReason.value || []);
const onRowSelect = (event) => {
  //console.log(event.data)
  toggleModal();
};

const remove = (args) => {
  Swal.fire({
    title: "İlgili kayıt silinsin mi?",
    text: "Emin misiniz? Bu işlemi geri alamazsınız!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Evet, Sil!",
    cancelButtonText: "İptal",
  }).then((result) => {
    // <--
    if (result.value) {
      // <-- if confirmed
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      store
        .dispatch(Actions.REMOVE_SUPPLIER, args.id)
        .then((x) => {
          store.dispatch(Actions.SUPPLIER_LIST).then((f) => {
            toast.add({
              severity: "success",
              summary: "İşlem Sonucu",
              detail: x.message,
              life: 3000,
            });
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          });
        })
        .catch((e) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      removableSort: "",
      showGridlines: "",
      value: _unref(store).state.SupplierModule.supplier.value,
      responsiveLayout: "scroll",
      selection: selectedSupplier.value,
      "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((selectedSupplier).value = $event)),
      selectionMode: "single",
      filters: filters.value,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((filters).value = $event)),
      filterDisplay: "menu",
      dataKey: "id",
      globalFilterFields: [
      'name',
      'country.name',
      'representative.name',
      'status',
    ],
      paginator: true,
      rows: 50,
      metaKeySelection: false,
      onRowSelect: onRowSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          selectionMode: "multiple",
          headerStyle: "width: 3em"
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "Üretici Adı",
          sortable: "",
          filterMatchMode: "contains",
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(data.name), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              placeholder: "Üreticiler İçinde Ara"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "isActive",
          header: "Durum",
          sortable: "",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", data.isActive ? 'badge-success' : 'badge-danger'])
            }, _toDisplayString(data.isActive ? "Aktif" : "Pasif"), 3)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(Dropdown), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              options: statusOptions.value,
              placeholder: "Durum Seçin",
              class: "p-column-filter",
              showClear: ""
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", slotProps.option.value ? 'badge-success' : 'badge-danger'])
                }, _toDisplayString(slotProps.option.label), 3)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 2))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              exportable: false,
              style: {"min-width":"8rem"},
              header: "İşlemler"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-rounded p-button-danger",
                  onClick: ($event: any) => (remove(slotProps.data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "selection", "filters", "globalFilterFields"]),
    (isActive.value)
      ? (_openBlock(), _createBlock(Update, {
          key: 0,
          isActive: isActive.value,
          id: selectedSupplier.value.id,
          name: selectedSupplier.value.name,
          active: selectedSupplier.value.isActive,
          onChangeReceipt: toggleModal
        }, null, 8, ["isActive", "id", "name", "active"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})